import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { apiBaseUrl } from "network";

export const planApi = createApi({
    reducerPath: "planApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiBaseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }), 

    endpoints: (builder) => ({
        updatePlan: builder.mutation({
            query: (body) => ({ url: "/backend/v1/coupon", method: "PUT", body: body }),
        }),
        addPlan: builder.mutation({
            query: (body) => ({ url: "/backend/v1/coupon", method: "POST", body: body }),
        }),
        getAllPlanList: builder.query({
            query: ({ page, limit, search }) => ({
                url: `/backend/v1/coupon?page=${page}&limit=${limit}&search=${search}`
            }),
            transformResponse: (response) => response
        }),
        
    })
})

export const { useAddPlanMutation,useGetAllPlanListQuery,useUpdatePlanMutation,useLazyGetAllPlanListQuery } = planApi;
